import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setAtividade } from "./actions/actions";
import { dateFormat, dateTimeFormat } from "../../util/DateUtil";

export default function AtividadeProfile() {
  const atividade = useSelector((state) => state.atividade);
  const dispatch = useDispatch();
  if (!atividade) return null;

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, p: 2 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "center" }}>
        <Box flexGrow={1} minWidth={0}>
          <Typography variant="caption" color="text.secondary">
            {atividade.tdp?.turma?.descricao} · {atividade.tdp?.disciplina?.descricao}
            {atividade.data && ` · ${dateFormat(atividade.data)}`}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600}>
            {atividade.descricao}
          </Typography>
          {(atividade.semNota || atividade.entrega) && (
            <Stack direction="row" spacing={0.5} mt={0.5} flexWrap="wrap" useFlexGap>
              {atividade.semNota && <Chip size="small" variant="outlined" label="Sem nota (visto)" />}
              {atividade.entrega && (
                <Chip
                  size="small"
                  variant="outlined"
                  color="secondary"
                  label={
                    atividade.dataLimiteEntrega
                      ? `Entrega até ${dateTimeFormat(atividade.dataLimiteEntrega)}`
                      : "Com entrega"
                  }
                />
              )}
            </Stack>
          )}
        </Box>
        <Button
          component={Link}
          to="/atividade"
          startIcon={<SwapHorizIcon />}
          onClick={() => dispatch(setAtividade(null))}
          sx={{ flexShrink: 0 }}
        >
          Trocar Atividade
        </Button>
      </Stack>
    </Paper>
  );
}
